import { inject, Injectable } from '@angular/core'
import { AppVisibilityService } from '../app-visibility.service'
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators'
import { BehaviorSubject } from 'rxjs'
import { PrimeNgToastService } from '../prime-ng-toast/prime-ng-toast.service'

@Injectable({
  providedIn: 'root',
})
export class ConnectionAlertService {
  private toaster = inject(PrimeNgToastService)
  private appVisibilityService = inject(AppVisibilityService)

  private isConnected$$ = new BehaviorSubject(true)
  private isConnected$ = this.isConnected$$.asObservable()
  private isAppInForeground$ = this.appVisibilityService.visibilityChange$
  private connectedStateWhenAppLastWentToBackground: boolean = true
  private firstToastShown = false
  private disconnectionToastShown = false

  private toastEmitter$ = this.isAppInForeground$.pipe(
    map((inForeground) => {
      if (!inForeground) this.saveConnectedState()
      return inForeground
    }),
    switchMap((inForeground) =>
      this.isConnected$.pipe(
        distinctUntilChanged(),
        debounceTime(3000),
        map((isConnected) => {
          if (inForeground) {
            this.showToastIfConnectedStateDiffers()
            this.clearSavedConnectedState()
          }
        }),
      ),
    ),
  )

  constructor() {
    this.toastEmitter$.subscribe()
  }

  async showDisconnectionToast() {
    this.firstToastShown = true
    this.disconnectionToastShown = true
    const disconnectedCssClass = 'disconnection-toast'

    this.toaster.displayCustomToast('warn', 'Ztraceno spojení se serverem, navazujeme připojení...', {
      icon: 'pi pi-bolt',
      styleClass: disconnectedCssClass,
    })
  }
  showConnectionToast() {
    if (!this.firstToastShown || !this.disconnectionToastShown) {
      this.firstToastShown = true
      return
    }

    this.disconnectionToastShown = false
    this.toaster.displayCustomToast('info', 'Spojení se serverem navázáno!', {
      icon: 'pi pi-heart',
      styleClass: 'connected-toast',
    })
  }

  async setState(connected: boolean) {
    this.isConnected$$.next(connected)
  }

  saveConnectedState() {
    this.connectedStateWhenAppLastWentToBackground = this.isConnected$$.getValue()
  }

  private showToastIfConnectedStateDiffers() {
    const isConnected = this.isConnected$$.getValue()

    if (isConnected !== this.connectedStateWhenAppLastWentToBackground) {
      if (isConnected) {
        this.showConnectionToast()
      } else {
        this.showDisconnectionToast()
      }
    }
  }

  private clearSavedConnectedState() {
    this.connectedStateWhenAppLastWentToBackground = null
  }
}
